import { useState } from "react";

const useTabs = (initialIndex = 0) => {
  const [value, setValue] = useState(initialIndex);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return { value, handleChange };
};

export default useTabs;
